import apiClient, { ApiResponse } from './api';
import { NewsArticle, NewsBookmark, NewsSource, NewsCategory } from '../types/portfolio';

class NewsService {
  // News Article endpoints
  async getArticles(params?: {
    page?: number;
    page_size?: number;
    search?: string;
    language?: string;
    category?: string;
  }): Promise<ApiResponse<{ count: number; results: NewsArticle[] }>> {
    return apiClient.get('/news/articles/', { params });
  }

  async getArticle(id: string): Promise<ApiResponse<NewsArticle>> {
    return apiClient.get(`/news/articles/${id}/`);
  }

  async getArticlesByCategory(
    category: NewsCategory,
    params?: { page?: number; page_size?: number }
  ): Promise<ApiResponse<{ count: number; results: NewsArticle[] }>> {
    return apiClient.get('/news/articles/by_category/', {
      params: { category, ...params },
    });
  }

  async getArticlesByInstrument(
    symbol: string,
    params?: { page?: number; page_size?: number }
  ): Promise<ApiResponse<{ count: number; results: NewsArticle[] }>> {
    return apiClient.get('/news/articles/by_instrument/', {
      params: { symbol, ...params },
    });
  }

  // Bookmark endpoints
  async getBookmarks(): Promise<ApiResponse<NewsBookmark[]>> {
    return apiClient.get('/news/bookmarks/');
  }

  async createBookmark(data: {
    article_id: string;
    notes?: string;
  }): Promise<ApiResponse<NewsBookmark>> {
    return apiClient.post('/news/bookmarks/', data);
  }

  async getBookmark(id: string): Promise<ApiResponse<NewsBookmark>> {
    return apiClient.get(`/news/bookmarks/${id}/`);
  }

  async updateBookmark(
    id: string,
    data: Partial<NewsBookmark>
  ): Promise<ApiResponse<NewsBookmark>> {
    return apiClient.put(`/news/bookmarks/${id}/`, data);
  }

  async deleteBookmark(id: string): Promise<ApiResponse<void>> {
    return apiClient.delete(`/news/bookmarks/${id}/`);
  }

  // News Source endpoints
  async getSources(): Promise<ApiResponse<NewsSource[]>> {
    return apiClient.get('/news/sources/');
  }
}

export default new NewsService();
